<template>
  <v-container class="login my-5">
    <v-layout row justify-space-around>
      <v-flex xs12 sm7 md5 lg4 xl3 class="text-xs-center">
        <v-card class="pa-5 mt-5 text-center">
          <div class="blue--text title font-weight-regular">
            Email Verification
          </div>
          <div class="ma-2">
            We've sent you an email to confirm your account.
          </div>

          <div class="mb-3">
            Please click the link in the email and then return to this page.

          </div>
          <v-btn large rounded color="blue" dark @click="checkState">
            I verified my email
          </v-btn>
          <div class="mt-3">
            Need help? Please email our <a href="mailto:support@omentum.freshdesk.com">support team</a>.
          </div>
          <v-alert class="mt-4" dense v-if="error" dark color="purple lighten-2">
            Looks like we didn't get your email verification. We've sent you another
             email to {{email}} to try again. Click the link in the email and try the button again.
          </v-alert>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import firebase from 'firebase'

export default {
  name: 'EmailVerify',
  data() {
    return {
      verified: firebase.auth().currentUser,
      email: firebase.auth().currentUser.email,
      error: false,

    }
  },
  mounted() {
    this.sendVerifyEmail()

  },
  methods: {
    sendVerifyEmail() {
      var user = firebase.auth().currentUser;


      let data = {email: firebase.auth().currentUser.email}
      let verifyEmail = firebase.functions().httpsCallable('verifyEmail')
      verifyEmail(data).then(res => {
        console.log(res)
      })


      // user.sendEmailVerification().then(result => {
      //   console.log(result)
      // }).catch(err => {
      //   console.log(err)
      // })
    },
    checkState() {
      firebase.auth().currentUser.reload().then(() => {
        if (firebase.auth().currentUser.emailVerified) {
          this.$router.push({name: 'Home'})
        }
        else {
          this.error = true
          this.sendVerifyEmail()
        }
      })

    }
  }
}
</script>
<style>

</style>
